type Props = {
  fillColor?: string;
  width?: string;
  height?: string;
} & typeof defaultProps;

const defaultProps = {
  fillColor: '#7E7E7E',
  width: '14px',
  height: '14px',
};
const EditIcon = function EditIcon(props: Props) {
  const { fillColor, width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: 'pointer' }}
      className="edit-icon"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.52972 13.2823L1.22945 13.3793H1.1971C0.88972 13.3793 0.59852 13.2499 0.388209 13.0396C0.16172 12.8293 0.032298 12.5219 0.0484757 12.1983L0.145542 8.89807C0.16172 8.60687 0.274965 8.33185 0.485276 8.12154L8.20208 0.388561C8.63888 -0.0644163 9.36688 -0.0644163 9.81985 0.388561L13.0231 3.60794C13.2495 3.81825 13.3628 4.10945 13.3628 4.41683C13.3628 4.72421 13.2334 5.01541 13.0231 5.22572L5.30625 12.9425C5.09594 13.1528 4.82092 13.2661 4.52972 13.2823ZM12.0039 4.40065L9.01096 1.40776L1.43976 8.99514L1.39123 10.4997L2.92812 12.0366L4.43265 11.988L12.0039 4.40065Z"
        fill={fillColor}
      />
      <path
        d="M3.75322 10.9522C3.88264 11.0817 4.04442 11.1464 4.20619 11.1464C4.36797 11.1464 4.52975 11.0817 4.65917 10.9522L10.5479 5.06353C10.8067 4.80469 10.8067 4.40024 10.5479 4.1414C10.289 3.88255 9.88459 3.88255 9.62575 4.1414L3.75322 10.0463C3.49437 10.289 3.49437 10.7096 3.75322 10.9522Z"
        fill={fillColor}
      />
      <path
        d="M2.92812 9.86903C3.08989 9.86903 3.25167 9.80432 3.38109 9.6749L9.26981 3.78619C9.52865 3.52734 9.52865 3.1229 9.26981 2.86406C9.01096 2.60521 8.60652 2.60521 8.34767 2.86406L2.47514 8.76894C2.21629 9.02779 2.21629 9.43223 2.47514 9.69108C2.60456 9.80432 2.76634 9.86903 2.92812 9.86903Z"
        fill={fillColor}
      />
    </svg>
  );
};
EditIcon.defaultProps = defaultProps;
export default EditIcon;
